import { ActionMap, FormContext_Actions } from '@/components/forms/FormContext';
import { ReplaceVirtuallyFormState } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';
import profiler from '@/helpers/userProfile/profiler';

/*******************************************************************************
 * Address Step Actions and Reducer
 */

export const AddressStepActions = {
	...FormContext_Actions,
	UPDATE_ADDRESS: 'UPDATE_ADDRESS',
	UPDATE_AVAILABLE_DEALER_COUNT: 'UPDATE_AVAILABLE_DEALER_COUNT',
} as const;

export type AddressStepAction = keyof typeof AddressStepActions;

export interface AddressStepActionPayload {
	[AddressStepActions.UPDATE_ADDRESS]: string;
	[AddressStepActions.UPDATE_AVAILABLE_DEALER_COUNT]: number | null;
}

export type AddressStepActionMap =
	ActionMap<AddressStepActionPayload>[keyof ActionMap<AddressStepActionPayload>];

export const isAddressStepActionMap = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
): action is AddressStepActionMap => action.type in AddressStepActions;

export const addressStepReducer = (
	state: ReplaceVirtuallyFormState,
	action: AddressStepActionMap,
): ReplaceVirtuallyFormState => {
	const [, setProfile] = profiler();
	switch (action.type) {
		case AddressStepActions.UPDATE_ADDRESS:
			setProfile('address', action.payload);
			return {
				...state,
				address: action.payload,
			};
		case AddressStepActions.UPDATE_AVAILABLE_DEALER_COUNT:
			return {
				...state,
				availableDealerCount: action.payload,
			};
		default:
			return state;
	}
};

export const isValid = (state: ReplaceVirtuallyFormState): boolean => {
	// Regex in english: 1 to 7 digits followed by an optional letter,
	// followed by a space, followed by one or more words, followed by a
	// comma, space, or hyphen, repeated one or more times, followed by a
	// space, followed by 4 or more digits.
	const pattern = /\d{1,7}\w? (?:\w+,? ?-?)+ \d{4,}/;
	return pattern.test(state.address);
};
